document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("career-form");
  const toast = document.getElementById("form-toast");

  const heading = document.querySelector(".pcb__heading");

  if (heading) {
    const params = new URLSearchParams(window.location.search);
    const page = params.get("page");

    if (page) {
      let label = page;

      if (page === "siege-social") label = "Siège social";
      else if (page === "usine") label = "Usine";
      else if (page === "support-technique") label = "Support technique";
      else {
        label = page
          .split("-")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      }

      heading.textContent = label;
    } else {
      heading.textContent = heading.dataset.baseHeading || heading.textContent;
    }
  }

  if (!form) return;

  const cvInput = document.querySelector('[name="cv_file"]');
  const letterInput = document.querySelector('[name="cover_letter"]');
  const formWrap = form.closest(".pcb__form-wrap");
  const loader = formWrap ? formWrap.querySelector(".career-loader") : null;

  function showToast(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("show");

    setTimeout(() => {
      toast.classList.remove("show");
    }, 3000);
  }

  function setLoading(state) {
    form.classList.toggle("form-loading", state);
    if (loader) loader.classList.toggle("active", state);

    form.querySelectorAll("input, textarea, select, button").forEach(el => {
      el.disabled = state;
    });
  }

  function isValidFile(file) {
    if (!file) return false;
    const allowed = ["pdf", "doc", "docx"];
    const ext = file.name.split(".").pop().toLowerCase();
    return allowed.includes(ext);
  }

  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const firstName = form.querySelector('[name="first_name"]').value.trim();
    const lastName = form.querySelector('[name="last_name"]').value.trim();
    const email = form.querySelector('[name="email"]').value.trim();
    const message = form.querySelector('[name="message"]').value.trim();
    const consent = form.querySelector('[name="consent"]').checked;

    if (!firstName) return showToast("Le prénom est obligatoire.");
    if (!lastName) return showToast("Le nom est obligatoire.");
    if (!email) return showToast("Le courriel est obligatoire.");
    if (!message) return showToast("Le message est obligatoire.");
    if (!consent) return showToast("Vous devez accepter le consentement.");

    const cvFile = cvInput.files[0];
    if (!cvFile) return showToast("Le CV est obligatoire.");
    if (!isValidFile(cvFile)) return showToast("CV invalide (PDF, DOC, DOCX).");

    const letterFile = letterInput.files[0];
    if (letterFile && !isValidFile(letterFile)) {
      return showToast("Lettre invalide (PDF, DOC, DOCX).");
    }

    const formData = new FormData(form);

    try {
      setLoading(true);

      const res = await fetch("https://sinto-one-prolab-327c8bdb5bc4.herokuapp.com/public-api/send-resume", {
        method: "POST",
        body: formData,
      });

      if (res.ok) {
        showToast("✅ Candidature envoyée !");
        form.reset();
      } else {
        showToast("Erreur lors de l’envoi.");
      }
    } catch (err) {
      showToast("Erreur réseau.");
    } finally {
      setLoading(false);
    }
  });
});